import * as actions from './profile.actions'

const initialState = {
  profileBattles: [],
}

const actionsMap = {
  [actions.SET_PROFILE_BATTLES]: (state, action) => {
    return {
      ...state,
      profileBattles: action.data,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
